var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "tabbar", staticClass: "emd-tabbar _bordered" }, [
    _c(
      "ul",
      { staticClass: "emd-tabbar__list display-grid", style: _vm.styleObject },
      _vm._l(_vm.visibleItems, function (item) {
        return _c(
          "li",
          {
            key: item.label.key,
            staticClass: "emd-tabbar__item",
            class: { _disabled: !_vm.hasPermission(item) },
          },
          [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: item.label.key === _vm.activeItem },
                on: {
                  click: function ($event) {
                    return _vm.action(item)
                  },
                },
              },
              [
                _c("span", { class: _vm.itemClass }, [
                  _c("b", [_vm._v(_vm._s(item.label.value))]),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }